import mammals1 from '../images/mammals/EV2A1050.jpg'
import mammals2 from '../images/mammals/QA1A9765.jpg'
import mammals3 from '../images/mammals/QA1A4001.jpg'
import mammals4 from '../images/mammals/EV2A8642.jpg'
import mammals5 from '../images/mammals/QA1A4603.jpg'
import mammals6 from '../images/mammals/QA1A2092.jpg'
import mammals7 from '../images/mammals/QE1A1371.jpg'
import mammals8 from '../images/mammals/QE1A4915.jpg'
import mammals9 from '../images/mammals/QE1A9394.jpg'
import mammals10 from '../images/mammals/QE1A6013.jpg'

export const mammalsData = [
  {
    id: 1,
    image: mammals1,
    alignment: 'horizontal',
    alt: 'mammals image 1 Jari Sokka'
  },
  {
    id: 2,
    image: mammals2,
    alignment: 'horizontal',
    alt: 'mammals image 2 Jari Sokka'
  },
  {
    id: 3,
    image: mammals3,
    alignment: 'horizontal',
    alt: 'mammals image 3 Jari Sokka'
  },
  {
    id: 4,
    image: mammals4,
    alignment: 'horizontal',
    alt: 'mammals image 4 Jari Sokka'
  },
  {
    id: 5,
    image: mammals5,
    alignment: 'horizontal',
    alt: 'mammals image 5 Jari Sokka'
  },
  {
    id: 6,
    image: mammals6,
    alignment: 'horizontal',
    alt: 'mammals image 6 Jari Sokka'
  },
  {
    id: 7,
    image: mammals7,
    alignment: 'horizontal',
    alt: 'mammals image 7 Jari Sokka'
  },
  {
    id: 8,
    image: mammals8,
    alignment: 'horizontal',
    alt: 'mammals image 8 Jari Sokka'
  },
  {
    id: 9,
    image: mammals9,
    alignment: 'horizontal',
    alt: 'mammals image 9 Jari Sokka'
  },
  {
    id: 10,
    image: mammals10,
    alignment: 'horizontal',
    alt: 'mammals image 10 Jari Sokka'
  }
]